import React from 'react';
import type { ReactChildren } from '@fluentui/react-northstar';
import { Page } from './Container.style';
import { useStyles, Container as ClampContainer } from '@archipro-design/aria';
import { ReactComponent as LogoIcon } from '@rocco/icons/svg/archipro-symbol-logo.svg';

interface ProjectContainerProps {
    children: ReactChildren;
}

const ENABLE_FLOATING_LOGO_BACKGROUND = false;
const Container = ({ children }: ProjectContainerProps) => {
    const { css } = useStyles();

    return (
        <div
            className={`${css(Page)} bg-white relative`}
            style={
                ENABLE_FLOATING_LOGO_BACKGROUND
                    ? {
                          backgroundSize: '100% 87.5rem',
                          backgroundRepeat: 'no-repeat',
                          backgroundImage:
                              'linear-gradient(to bottom, #EEEEEE, #FFFFFF)',
                          backgroundPosition: 'center top',
                      }
                    : {}
            }
        >
            {ENABLE_FLOATING_LOGO_BACKGROUND && (
                <div className="hidden md:block fixed top-10 left-1/2 z-1 pointer-events-none">
                    <LogoIcon />
                </div>
            )}
            <ClampContainer
                className="relative z-10"
                style={{ background: 'transparent' }}
            >
                {children}
            </ClampContainer>
        </div>
    );
};

export default Container;
